// extracted by mini-css-extract-plugin
export default {"verticalCenter":"Culture_verticalCenter__NAcsM","title":"Culture_title__oK15z","imgStyle":"Culture_imgStyle__goiQV","largeImg":"Culture_largeImg__P5awP"};